import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useTransactions() {
  return useQuery({
    queryKey: ["transactions"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("transactions")
        .select("*")
        .order("date", { ascending: false });

      if (error) throw error;

      const parsedData =
        data?.map((transaction) => {
          let amount = Number(transaction.amount);

          let type;
          if (transaction.category === "Investment") {
            type = "Investment";
            // Keep the amount sign, don't flip it based on type for investment
          } else if (transaction.category === "Credit Card Payment") {
            type = "Credit Card Payment";
            // Keep the amount sign as is for credit card payments
          } else if (transaction.category === "Income" || amount > 0) {
            type = "Income";
            if (amount < 0) amount = -amount;
          } else {
            type = "Expense";
            if (amount > 0) amount = -amount;
          }

          return {
            ...transaction,
            amount,
            type,
          };
        }) || [];

      return parsedData;
    },
  });
}
